/********************************************************************
 *  PROVINCE ENGINE — UNIVERSAL VERSION FOR XO + PDP + STICKY-CART
 ********************************************************************/

document.addEventListener("DOMContentLoaded", () => {


  /* ===============================================================
     HELPERS
  =============================================================== */

  function getProvince() {
    return (localStorage.getItem("ageGateProvince") || "").toUpperCase();
  }

  function getProductJson() {
    const el = document.querySelector("script[id^='xo-product-json']");
    if (!el) return null;
    try { return JSON.parse(el.textContent); }
    catch { return null; }
  }

  /* ===============================================================
     GET ALL VARIANT UI NODES (with Shadow DOM support)
  =============================================================== */

  function getAllVariantNodes() {
    let nodes = Array.from(document.querySelectorAll("[data-province-code]"));

    document.querySelectorAll("xo-modal").forEach(mod => {
      if (mod.shadowRoot) {
        nodes = nodes.concat(Array.from(mod.shadowRoot.querySelectorAll("[data-province-code]")));
      }
    });

    document.querySelectorAll("xo-popover").forEach(pop => {
      if (pop.shadowRoot) {
        nodes = nodes.concat(Array.from(pop.shadowRoot.querySelectorAll("[data-province-code]")));
      }
    });

    return nodes;
  }

  /********************************************************************
   * QUICK VIEW FILTER — ONLY runs inside QuickView modal
  ********************************************************************/
  function applyProvinceFilterQuickView() {
    const province = getProvince();
    if (!province) return;

    console.log("[QuickView] Filtering for:", province);

    const modal = document.querySelector("xo-modal[xo-name='quick-view']");
    if (!modal) return;

    let nodes = [];

    // Shadow DOM
    if (modal.shadowRoot) {
      nodes = nodes.concat(Array.from(modal.shadowRoot.querySelectorAll("[data-province-code]")));
    }

    // Light DOM
    nodes = nodes.concat(Array.from(modal.querySelectorAll("[data-province-code]")));

    if (!nodes.length) {
      console.warn("[QuickView] No nodes");
      return;
    }

    let first = null;

    nodes.forEach(node => {
      const code = (node.dataset.provinceCode || "").toUpperCase();
      const show = code === province;
      node.style.display = show ? "" : "none";

      if (show && !first) {
        first = node.querySelector("input, option");
      }
    });

    if (first) {
      if (first.tagName === "OPTION") {
        const sel = first.closest("select");
        sel.value = first.value;
        sel.dispatchEvent(new Event("change", { bubbles: true }));
      } else {
        first.checked = true;
        first.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  }

  /* ===============================================================
     MAIN FILTER FUNCTION
  =============================================================== */

  window.applyProvinceFilter = function(forceProvince) {
    const province = (forceProvince || getProvince()).toUpperCase();
    if (!province) return;

    
    // console.log("[ProvinceEngine] Filtering UI:", province);

    const nodes = getAllVariantNodes();
    let first = null;

    nodes.forEach(node => {
      const prov = (node.dataset.provinceCode || "").toUpperCase();
      const show = prov === province;
      node.style.display = show ? "" : "none";

      if (show && !first) {
        first = node.querySelector("input, option");
      }
    });

    if (first) {
      if (first.tagName === "OPTION") {
        const sel = first.closest("select");
        sel.value = first.value;
        sel.dispatchEvent(new Event("change", { bubbles: true }));
      } else {
        first.checked = true;
        first.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    forceCorrectVariant();
      // 🔥 Notify rest of site (Ultra Hero, Sticky Cart, etc.)
      window.dispatchEvent(
        new CustomEvent("province:changed", {
          detail: { province }
        })
      );

  };

  /* ===============================================================
     FORCE XO INTERNAL VARIANT
  =============================================================== */

  function forceCorrectVariant() {
    const province = getProvince();
    if (!province) return;

    const product = getProductJson();
    if (!product) return;

    const variant = product.variants.find(
      v => (v.title.includes(province)
));

    if (!variant) {
      console.warn("No variant for province", province);
      return;
    }

    const xoProduct = document.querySelector("xo-product");
    if (xoProduct) {
      xoProduct.setAttribute("xo-selected-or-first-available-variant-id", variant.id);
      xoProduct.dispatchEvent(new CustomEvent("variant:change", { bubbles: true, detail: { variant }}));
    }

    document.querySelectorAll("xo-product-will-change").forEach(el => {
      el.dispatchEvent(new CustomEvent("variant:change", { bubbles: true, detail: { variant }}));
    });

    updateXOCartButtons(variant.id);
    window.__provinceVariantId = variant.id;
  }

  /* ===============================================================
     UPDATE ATC BUTTONS
  =============================================================== */

  function updateXOCartButtons(id) {
    document.querySelectorAll("xo-cart-add, .xo-add-to-cart--unavailable").forEach(btn => {
      btn.setAttribute("data-variant-id", id);
      btn.setAttribute("xo-variant-id", id);
    });
  }


    function applyProvinceFilterQuickView() {
        const province = (localStorage.getItem("ageGateProvince") || "").toUpperCase();
        if (!province) return;

        console.log("[QuickView] Running filter for:", province);

        // 1 — find Quick View modal
        const modal = document.querySelector("xo-modal[xo-name='quick-view']");
        if (!modal) return;

        // 2 — find the xo-product-quick-view element
        const qv = modal.querySelector("xo-product-quick-view");
        if (!qv) {
            console.warn("[QuickView] xo-product-quick-view not found yet");
            return;
        }

        // 3 — Quick View real content is inside SHADOW ROOT
        const root = qv.shadowRoot;
        if (!root) {
            console.warn("[QuickView] shadowRoot not ready yet");
            return;
        }

        // 4 — find variant nodes INSIDE the shadow root
        let nodes = Array.from(root.querySelectorAll("[data-province-code]"));

        if (!nodes.length) {
            console.warn("[QuickView] No variant nodes found inside shadowRoot");
            return;
        }

        let firstMatch = null;

        nodes.forEach(node => {
            const code = (node.dataset.provinceCode || "").toUpperCase();
            const show = code === province;

            node.style.display = show ? "" : "none";

            if (show && !firstMatch) {
            firstMatch = node.querySelector("input[type='radio'], option");
            }
        });

        // 5 — Auto-select correct variant
        if (firstMatch) {
            if (firstMatch.tagName === "OPTION") {
            const sel = firstMatch.closest("select");
            sel.value = firstMatch.value;
            sel.dispatchEvent(new Event("change", { bubbles: true }));
            } else {
            firstMatch.checked = true;
            firstMatch.dispatchEvent(new Event("change", { bubbles: true }));
            }
        }

        console.log("[QuickView] Filter applied successfully.");
    }


  /* ===============================================================
     QUICK VIEW EVENT LISTENERS
  =============================================================== */

  document.addEventListener("quickview:opened", () =>
    setTimeout(applyProvinceFilterQuickView, 150)
  );

  document.addEventListener("xo:modal:ready", () =>
    setTimeout(applyProvinceFilterQuickView, 150)
  );

  document.addEventListener("xo:variant-options:rendered", () =>
    setTimeout(applyProvinceFilterQuickView, 200)
  );

  /* ===============================================================
     INITIAL LOAD
  =============================================================== */

  setTimeout(() => {
    const p = getProvince();
    if (p) applyProvinceFilter(p);
  }, 200);

});
